import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { trackException } from './services/firebase';

if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Global error tracking (GA4)
try {
  if (typeof window !== 'undefined') {
    window.addEventListener('error', (e) => {
      try {
        trackException(e?.error || e?.message || 'window.error', {
          fatal: false,
          source: e?.filename,
          line: e?.lineno,
          col: e?.colno,
        });
      } catch {}
    });
    window.addEventListener('unhandledrejection', (e) => {
      try {
        const reason = e?.reason;
        const message =
          (reason && (reason.message || reason.toString && reason.toString())) ||
          'unhandledrejection';
        trackException(message, { fatal: false });
      } catch {}
    });
  }
} catch {}

